<template>
  <div class="page">
    <!-- 统一风格页头 -->
    <div class="page-header">
      <div class="header-left">
        <h1 class="page-title">訂單列表</h1>
      </div>
      <div class="header-right">
        <!-- 可扩展添加导出/批量操作等按钮 -->
      </div>
    </div>

    <div class="layout">
      <!-- 统一风格搜索区 -->
      <div class="search-card">
        <div class="search-row">
          <div class="search-item">
            <div class="search-text">訂單編號</div>
            <el-input
                size="small"
                v-model="formLabelAlign.orderNoLike"
                placeholder="請輸入訂單編號"
                prefix-icon="el-icon-order"
                clearable
            ></el-input>
          </div>
          <div class="search-item">
            <div class="search-text">用戶電郵</div>
            <el-input
                size="small"
                v-model="formLabelAlign.email"
                placeholder="請輸入用戶電郵"
                prefix-icon="el-icon-message"
                clearable
            ></el-input>
          </div>
          <div class="search-item">
            <div class="search-text">訂單日期</div>
            <el-date-picker
                size="small"
                v-model="formLabelAlign.orderDate"
                type="date"
                placeholder="請選擇日期"
                value-format="yyyy-MM-dd"
                clearable
            >
            </el-date-picker>
          </div>
          <div class="search-item">
            <div class="search-text">付款類型</div>
            <el-select
                size="small"
                v-model="formLabelAlign.payType"
                clearable
                placeholder="全部"
            >
              <el-option
                  v-for="(item, index) in paymentType.filter(item => item.label !== '升級')"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="search-item">
            <div class="search-text">付款狀態</div>
            <el-select
                size="small"
                v-model="formLabelAlign.status"
                clearable
                placeholder="全部"
            >
              <el-option
                  v-for="(item, index) in payStatus"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
              ></el-option>
            </el-select>
          </div>
          <div class="search-buttons">
            <el-button size="small" type="warning" @click="onSearch" icon="el-icon-search">搜尋</el-button>
            <el-button size="small" @click="onReset" icon="el-icon-refresh">重置</el-button>
          </div>
        </div>
      </div>

      <!-- 统一风格 PC表格 + 手机卡片 -->
      <div class="table-container">
        <!-- PC端表格（≥768px显示） -->
        <div class="pc-table">
          <el-table
              @sort-change="handleSortChange"
              :data="tableData"
              style="width: 100%"
              border
              stripe
              size="small"
              :empty-text="tableData.length === 0 ? '暫無訂單數據' : ''"
          >
            <el-table-column label="#" type="index" width="50"> </el-table-column>
            <el-table-column
                prop="orderNo"
                label="訂單編號"
                align="center"
                sortable="custom"
                min-width="120"
            >
            </el-table-column>
            <el-table-column
                prop="createdAt"
                label="訂單日期"
                width="180"
                align="center"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <span>{{ row.createdAt | formatDateTime }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="userNo"
                label="用戶帳號"
                align="center"
                sortable="custom"
                min-width="100"
            >
              <template slot-scope="{ row }">
                <span>{{ row.parent?.userNo || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="email"
                label="用戶電郵"
                align="center"
                sortable="custom"
                min-width="180"
            >
              <template slot-scope="{ row }">
                <span>{{ row.parent?.email || '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="payPrice"
                label="訂單金額"
                width="120"
                align="center"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <span>¥{{ row.payPrice || 0 }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="payType"
                label="付款類型"
                width="120"
                align="center"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <el-tag :type="getPayTypeTagType(row.payType)" size="mini">
                  {{ row.payType | paymentType }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column
                prop="status"
                label="支付狀態"
                width="120"
                align="center"
                sortable="custom"
            >
              <template slot-scope="{ row }">
                <el-tag :type="getPayStatusTagType(row.status)" size="mini">
                  {{ row.status | payStatus }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180" align="center">
              <template slot-scope="{ row }">
                <el-button
                    type="text"
                    v-if="row.payType !== 0"
                    size="small"
                    @click="onEditButton(row.id)"
                    icon="el-icon-edit"
                >編輯</el-button>
                <el-button
                    type="text"
                    size="small"
                    @click="onDetailButton(row.id)"
                    icon="el-icon-view"
                >詳情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 手机端卡片列表（<768px显示） -->
        <div class="mobile-cards">
          <div class="order-card" v-for="(item) in tableData" :key="item.id">
            <!-- 卡片头部：订单编号 + 日期 -->
            <div class="card-header">
              <div class="order-info">
                <div class="order-no">{{ item.orderNo }}</div>
                <div class="order-date">{{ item.createdAt | formatDateTime }}</div>
              </div>
              <el-tag
                  :type="getPayStatusTagType(item.status)"
                  size="mini"
              >
                {{ item.status | payStatus }}
              </el-tag>
            </div>

            <!-- 卡片主体：核心信息 -->
            <div class="card-body">
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">用戶帳號：</span>
                  <span class="info-value">{{ item.parent?.userNo || '未填寫' }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">用戶電郵：</span>
                  <span class="info-value">{{ item.parent?.email || '未填寫' }}</span>
                </div>
              </div>
              <div class="info-row">
                <div class="info-item">
                  <span class="info-label">訂單金額：</span>
                  <span class="info-value price">¥{{ item.payPrice || 0 }}</span>
                </div>
                <div class="info-item">
                  <span class="info-label">付款類型：</span>
                  <el-tag
                      :type="getPayTypeTagType(item.payType)"
                      size="mini"
                  >
                    {{ item.payType | paymentType }}
                  </el-tag>
                </div>
              </div>
            </div>

            <!-- 卡片操作栏 -->
            <div class="card-actions">
              <el-button
                  type="text"
                  v-if="item.payType !== 0"
                  size="mini"
                  @click="onEditButton(item.id)"
                  icon="el-icon-edit"
              >編輯</el-button>
              <el-button
                  type="text"
                  size="mini"
                  @click="onDetailButton(item.id)"
                  icon="el-icon-view"
              >詳情</el-button>
            </div>
          </div>

          <!-- 空数据提示 -->
          <div class="empty-tip" v-if="tableData.length === 0">
            暫無訂單數據
          </div>
        </div>
      </div>

      <!-- 分页组件 -->
      <div class="pagination-wrap">
        <Pagination
            v-show="total > 0"
            :total="total"
            :page.sync="formLabelAlign._page"
            :limit.sync="formLabelAlign._limit"
            @pagination="getOrders"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination";
import { getOrders } from "@/api/order";

export default {
  components: { Pagination },
  filters: {
    // 格式化日期时间（补充默认实现，可根据实际需求调整）
    formatDateTime(val) {
      if (!val) return '-';
      // 简单实现：如果是时间戳转日期，或者格式化字符串
      const date = new Date(val);
      return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    },
    // 付款类型过滤器（补充默认实现，可根据实际枚举值调整）
    paymentType(val) {
      const payTypeMap = {
        0: '未知',
        1: '微信支付',
        2: '支付宝',
        3: '银行卡',
        4: '现金'
      };
      return payTypeMap[val] || '未知';
    },
    // 支付状态过滤器（补充默认实现，可根据实际枚举值调整）
    payStatus(val) {
      const payStatusMap = {
        0: '未支付',
        1: '已支付',
        2: '已退款',
        3: '支付失败'
      };
      return payStatusMap[val] || '未知';
    }
  },
  data() {
    return {
      total: 0,
      // 补充付款状态枚举（根据实际业务调整）
      payStatus: [
        { label: '未支付', value: 0 },
        { label: '已支付', value: 1 },
        { label: '已退款', value: 2 },
        { label: '支付失败', value: 3 }
      ],
      // 补充付款类型枚举（根据实际业务调整）
      paymentType: [
        { label: '未知', value: 0 },
        { label: '微信支付', value: 1 },
        { label: '支付宝', value: 2 },
        { label: '银行卡', value: 3 },
        { label: '现金', value: 4 },
        { label: '升級', value: 5 }
      ],
      orderId: null,
      dialogSlotVisible: false,
      centerDialogVisible: false,
      formLabelAlign: {
        orderNoLike: null,
        email: null,
        orderDate: null,
        status: null,
        payType: null,
        orderBy: null,
        _page: 1,
        _limit: 10,
      },
      tableData: [],
    };
  },
  created() {
    this.getOrders();
  },
  methods: {
    // 获取付款类型标签样式
    getPayTypeTagType(payType) {
      const typeMap = {
        0: 'info',
        1: 'success',
        2: 'primary',
        3: 'warning',
        4: 'default'
      };
      return typeMap[payType] || 'info';
    },
    // 获取支付状态标签样式
    getPayStatusTagType(status) {
      const typeMap = {
        0: 'danger',    // 未支付
        1: 'success',   // 已支付
        2: 'warning',   // 已退款
        3: 'info'       // 支付失败
      };
      return typeMap[status] || 'info';
    },
    // 排序处理
    handleSortChange(column) {
      this.formLabelAlign.orderBy = column.order ? `${column.prop} ${column.order === "descending" ? "desc" : "asc"}` : null;
      this.formLabelAlign._page = 1;
      this.getOrders();
    },
    // 重置搜索条件
    onReset() {
      Object.keys(this.formLabelAlign).forEach((key) => {
        this.formLabelAlign[key] = null;
        if(key === '_page'){
          this.formLabelAlign[key] = 1;
        }
        if(key === '_limit'){
          this.formLabelAlign[key] = 10; // 恢复默认10条/页
        }
      });
      this.getOrders();
    },
    // 搜索
    onSearch() {
      this.formLabelAlign._page = 1; // 搜索后重置页码
      this.getOrders();
    },
    // 编辑订单
    onEditButton(id) {
      let path = `/order/${id}/edit`;
      this.resolveRouter(path);
    },
    // 订单详情
    onDetailButton(id) {
      let path = `/order/${id}`;
      this.resolveRouter(path);
    },
    // 路由跳转（补充实现）
    resolveRouter(path) {
      this.$router.push(path);
    },
    // 获取订单列表
    getOrders() {
      let formLabelAlign = {
        orderNoLike: this.formLabelAlign.orderNoLike,
        email: this.formLabelAlign.email,
        status: this.formLabelAlign.status,
        payType: this.formLabelAlign.payType,
        orderBy: this.formLabelAlign.orderBy,
        startDate: this.formLabelAlign.orderDate,
        endDate: this.formLabelAlign.orderDate,
        _page: this.formLabelAlign._page - 1,
        _limit: this.formLabelAlign._limit,
      };
      // 清空空值参数
      Object.keys(formLabelAlign).forEach(key => {
        if (formLabelAlign[key] === null || formLabelAlign[key] === undefined) {
          delete formLabelAlign[key];
        }
      });
      getOrders(formLabelAlign).then((v) => {
        this.tableData = v.data || [];
        this.total = Number(v.headers["x-total-count"]) || 0;
      }).catch(err => {
        this.$message.error("獲取訂單列表失敗，請稍後重試");
        console.error('获取订单失败：', err);
        this.tableData = [];
        this.total = 0;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/* 基础样式 */
.page {
  padding: 16px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

/* 统一风格页头 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e4e7ed;

  .header-left {
    .page-title {
      font-size: 20px;
      font-weight: 600;
      color: #B62D2E;
      margin: 0;
    }
  }

  .header-right {
    display: flex;
    gap: 8px;
  }
}

/* 布局容器 */
.layout {
  background: #fff;
  border-radius: 8px;
  //padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

/* 统一风格搜索卡片 */
.search-card {
  background: #f8f9fa;
  padding: 16px;
  border-radius: 6px;
  margin-bottom: 20px;

  .search-row {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    align-items: flex-end;

    .search-item {
      flex: 1;
      width: 100%;
      min-width: unset;

      .search-text {
        margin-bottom: 4px;
        font-size: 12px;
        color: #6c757d;
        font-weight: 500;
      }
    }

    .search-buttons {
      display: flex;
      gap: 8px;
      flex-shrink: 0;
      padding-bottom: 24px; // 对齐输入框底部
    }
  }
}

/* 表格/卡片容器 */
.table-container {
  width: 100%;
  //margin-bottom: 20px;

  /* PC端表格样式 */
  .pc-table {
    ::v-deep .el-table {
      --el-table-header-text-color: #4e5969;
      --el-table-row-hover-bg-color: #f8f9fa;
    }

    ::v-deep .el-table th {
      background: #f8f9fa;
      font-weight: 600;
    }
  }

  /* 手机端卡片列表样式 */
  .mobile-cards {
    display: none;
    gap: 12px;
    flex-direction: column;

    .order-card {
      background: #fff;
      border: 1px solid #e9ecef;
      border-radius: 8px;
      padding: 16px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

      /* 卡片头部 */
      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 12px;
        padding-bottom: 8px;
        border-bottom: 1px solid #f1f3f5;

        .order-info {
          flex: 1;

          .order-no {
            font-size: 16px;
            font-weight: 600;
            color: #1f2937;
            margin-bottom: 4px;
          }

          .order-date {
            font-size: 12px;
            color: #6c757d;
          }
        }
      }

      /* 卡片主体 */
      .card-body {
        margin-bottom: 12px;

        .info-row {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-bottom: 8px;
          align-items: center;

          .info-item {
            display: flex;
            align-items: center;
            gap: 4px;
            width: 100%;

            .info-label {
              color: #6c757d;
              font-size: 12px;
              white-space: nowrap;
              width: 80px;
            }

            .info-value {
              color: #1f2937;
              font-size: 12px;
              flex: 1;
              word-break: break-all;

              &.price {
                font-weight: 600;
                color: #e64340;
              }
            }
          }
        }
      }

      /* 卡片操作栏 */
      .card-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        padding-top: 12px;
        border-top: 1px solid #f1f3f5;

        .el-button {
          padding: 4px 8px;
          font-size: 12px;
        }
      }
    }

    .empty-tip {
      text-align: center;
      padding: 32px;
      color: #999;
      font-size: 14px;
    }
  }
}

/* 分页样式 */
.pagination-wrap {
  text-align: center;
  ::v-deep .el-pagination {
    --el-pagination-button-bg-color: #fff;
    --el-pagination-button-hover-bg-color: #f8f9fa;
    --el-pagination-button-active-bg-color: #409eff;
  }
}

/* 响应式适配 */
@media (max-width: 768px) {
  .page {
    padding: 8px;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
    padding-bottom: 8px;
  }

  .layout {
    padding: 12px;
  }

  /* 搜索栏垂直排列 */
  .search-card .search-row {
    flex-direction: column;
    align-items: stretch;
    gap: 10px;
  }

  .search-card .search-row .search-item {
    width: 100% !important;
    min-width: unset !important;
  }

  .search-card .search-row .search-buttons {
    padding-bottom: 0;
  }

  /* 隐藏PC表格，显示手机卡片 */
  .table-container .pc-table {
    display: none;
  }

  .table-container .mobile-cards {
    display: flex;
  }
}
</style>